import { Toast } from '@journ/lotus/toast'
import { registerServiceWorker } from '_/features/sw/register-sw'
import { useIsomorphicEffect } from '_/hooks/use-isomorphic-effect'

// Push opt-in lives with the rest of the feature, in
// features/notifications/ui/hooks/use-push-subscription, next to the inbox it
// feeds. This only has to get the worker registered; everything else waits on
// navigator.serviceWorker.ready.
const ServiceWorkerRegistrar = () => {
	useIsomorphicEffect(() => {
		registerServiceWorker(({ update }) => {
			Toast.show('A new version is ready.', {
				duration: Number.POSITIVE_INFINITY,
				action: {
					label: 'Reload',
					onClick: () => {
						void update()
					},
				},
			})
		})
	}, [])

	return null
}

export { ServiceWorkerRegistrar }
